// @flow

import type { State } from "@store/reducers";
import type { HierarchyAssignment } from "@modules/service/types";
import type {
  WellbeingService,
  WellbeingServiceContent,
} from "@modules/service/reducer/wellbeing-services/types";
import { validateHierarchyAssignmentSchema } from "./index";

export const isLoading = (state: Object) => {
  return state.service.wellbeingServices.requestsInProgress > 0;
};

export const wellbeingServicesList = (state: State): Array<WellbeingService> =>
  state.service.wellbeingServices.list?.content || [];

export const getCurrentWellbeingServiceDetails = (state: State): ?WellbeingService =>
  state.service.wellbeingServices.current;

export const getWellbeingServiceAssignments = (state: State): Array<HierarchyAssignment> =>
  state.service.wellbeingServices.assignments;

export const getWellbeingServiceDraftAssignments = (state: State): Array<HierarchyAssignment> =>
  state.service.wellbeingServices.draftAssignments;

export const getWellbeingServicesDraft = (state: State): ?WellbeingServiceContent =>
  state.service.wellbeingServices.draft;

export const isWellbeingServiceDraftAssignmentsValid = (state: State): boolean => {
  const assignments = getWellbeingServiceDraftAssignments(state);
  return validateHierarchyAssignmentSchema(assignments);
};

export const isWellbeingServiceAssignmentsValid = (state: State): boolean => {
  const assignments = getWellbeingServiceAssignments(state);
  return validateHierarchyAssignmentSchema(assignments);
};

export const getWellbeingServiceReasonSpecificUsage = (state: State, status: string) => {
  const eap = getCurrentWellbeingServiceDetails(state);
  const eapRevision = eap ? eap[status] : null;

  if (!eapRevision) {
    return null;
  }

  return eapRevision.reasonSpecificUsages;
};

// EAP SCHEMA

export const getWellbeingServiceSchema = (state: State): ?Object =>
  (state.service.wellbeingServices || {}).schema;

export const getWellbeingServiceMainDetailsSchema = (state: State): Object | null => {
  const eapSchema1 = getWellbeingServiceSchema({ ...state });
  if (eapSchema1 && eapSchema1.properties) {
    // Cloning the object in order to delete safetly the reasonSpecificUsages prop
    const eapSchema = JSON.parse(JSON.stringify(eapSchema1));
    delete eapSchema.properties.reasonSpecificUsages;
    return eapSchema;
  }
  return null;
};

export const getWellbeingServiceReasonSpecificUsageSchema = (state: State): Object | null => {
  const eapSchema = getWellbeingServiceSchema(state);
  return eapSchema && eapSchema.properties ? eapSchema.properties.reasonSpecificUsages : null;
};

// EAP MODALS

export const getShowWellbeingAddModal = (state: State): boolean =>
  state.service.wellbeingServices.modals.showAddModal;

export const getShowEditModal = (state: State): boolean =>
  state.service.wellbeingServices.modals.showEditModal;

export const getShowEditAssignmentsModal = (state: State): boolean =>
  state.service.wellbeingServices.modals.showEditAssignmentsModal;

export const getModalStep = (state: State): number =>
  state.service.wellbeingServices.modals.modalStep;

export const getShowDisableModal = (state: State): boolean =>
  state.service.wellbeingServices.modals.showDisableModal;
